export default "__VITE_ASSET__BUDAlQjc__"